import { render } from "./RateCategoryTable.vue?vue&type=template&id=fd0c93c4&scoped=true"
import script from "./RateCategoryTable.vue?vue&type=script&lang=js"
export * from "./RateCategoryTable.vue?vue&type=script&lang=js"

import "./RateCategoryTable.vue?vue&type=style&index=0&id=fd0c93c4&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd0c93c4"]])

export default __exports__